<script>
import AppBanner from '@/components/shared/AppBanner';
import ListaMuzee from '../components/ListaMuzee.vue';
// import Button from '../components/reusable/Button.vue';

export default {
	name: 'Home',
	components: {
		AppBanner,
		ListaMuzee,
		// Button,
	},
	created() {
		// console.log(this.$i18n);
	},
	methods: {
		goToSchedule() {
			const locale = this.$store.getters.getLocale;
			console.log(locale);
			if (locale == 'ro') {
				window.open('https://www.delfinariu.ro/#ProgramVizitare', '_blank');
			} else {
				window.open('https://www.delfinariu.ro/#ProgramVizitare', '_blank');
			}
		},
	}
};
</script>

<template>
		<!-- Banner -->
		<AppBanner class="mb-5 sm:mb-8" />
		<!-- Muzee -->
		<div class="container mx-auto">
		<ListaMuzee :stateFilter="false" :searchFilter="false" pageTitle="what_to_visit"/>
		</div>

		<div class="container mx-auto mt-10">
			<button @click="goToSchedule()" class="mt-3 mb-2 font-bold px-2 py-1 flex align-center" 
			style="border-radius: 20px; padding: 10px 20px 8px; border: 1px solid #000; background-color: #ffffff; display: block; width: 100%; justify-content: center;">
				<span class="mr-1">{{$t("go_to_schedule")}}</span>
			</button>	
		</div>

		<div class="container mx-auto mt-10">
			<h3 class="text-lg mb-2">Info</h3>
			<li>Preturile biletelor includ T.V.A. si administrarea comenzii.</li>
			<li>Daca ati achizitionat bilete la Delfinariu sau Planetariu, nu mai este necesar sa achizitionati si pentru Microrezervatie.</li>
		</div>

		<!-- Load more projects button -->
		<!-- <div class="mt-10 sm:mt-20 flex justify-center">
			<router-link
				to="/projects"
				class="font-general-medium flex items-center px-6 py-3 rounded-lg shadow-lg hover:shadow-xl bg-indigo-500 hover:bg-indigo-600 focus:ring-1 focus:ring-indigo-900 text-white text-lg sm:text-xl duration-300"
				aria-label="More Projects"
			>
				<Button title="More Projects" />
			</router-link>
		</div> -->
</template>

<style scoped></style>
